import AppState from '../../interfaces/app-state';

export const selectVoucherItems = (state: AppState) => state.voucher.voucherItems;
